import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { MaterielEau } from "./materiel-eau";

export class MeasureEau {
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    MaterielEau!: MaterielEau;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    TakeAnotherDay: boolean = false;
    @AutoMap()
    ReferenceEtiquette?: string
    @AutoMap()
    Position!: number;

    public constructor(init?: Partial<MeasureEau>) {
        Object.assign(this, init);
    }
}